import { render, staticRenderFns } from "./MediaEditCard.vue?vue&type=template&id=237cd270&"
import script from "./MediaEditCard.vue?vue&type=script&lang=js&"
export * from "./MediaEditCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports